import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { playlistSlice } from '../../../reducers'
import { routes } from '../../../router/routes'

const useBack = () => {
  const navigate = useNavigate()
  const {
    url = routes.playlists.path,
    text = 'Back to Playlists'
  } = useSelector(playlistSlice.selectors.selectBack)

  const nav = () => navigate(url)

  const target = () => text

  return { nav, target }
}

export default useBack
